import React from 'react'
import { encodeToUrlParams, getContentfulImageURL } from '../../../../lib/helpers';
import { Link } from 'gatsby';
import CategoryTag from '../../General/CategoryTag';

const BloomCollectionsSection = ({data}) => {
    const collections= data.v2HighlightedCollections;

    return (
        <div className='collections-section'>
            <div className="collections-intro">

                <h5 className='section-title'>{data.v2CollectionsHeading?.v2CollectionsHeading}</h5>
                <p>{data.v2CollectionsDescription?.v2CollectionsDescription}</p>
            </div>

            <div className="collections">
                {collections.map((collection, idx) => {
                    const collectionTags = collection.tags.map((tag) => tag.name);
                    return (
                        <div className={`collection-link collection-${idx} ${idx === 0 ? "large" : "small"}`}>
                        
                            <div>
                                <img src={getContentfulImageURL(collection.image.file.url, 700, 85)} alt="" />
                                <div className="label">
                                    
                                    <h5 className="collection-title elizeth">{collection.name}</h5>
                                    <div className="cta-links">
                                        <Link to={`/articles/?${encodeToUrlParams(collectionTags, "tags")}`}><CategoryTag>Explore</CategoryTag></Link> 
                                        <h6 className='cta-link'>
                                            all {collectionTags.map((tag, idx) => {return <Link key={`bcs-${idx}`} to={`/articles/?${encodeToUrlParams([tag], "tags")}`}>{tag}{idx < collectionTags.length - 1 ? ", " : ""}</Link>})} articles.
                                        </h6>
                                    </div>
                                </div>

                            </div>
                        
                        </div>


                    )
                })}
            </div>



            <style jsx>{`
                .collections-section {
                    padding: 100px 60px;
                    background: #f4f4f4;
                }

                .collection-link {
                    display: block;
                    height: 0;
                    padding-bottom: 110%;
                    position: relative;
                    overflow: hidden;
                    border-radius: 15px;
                }

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    z-index: 0;
                }

                .label {
                    position: absolute;
                    bottom: 20px;
                    left: 20px;
                    z-index: 1;
                }

                .collection-title {
                    color: white;
                    // font-weight: 400;
                    max-width: 70%;
                }

                .collections-intro {
                    text-align: center;
                }

                .collections {
                    padding: 100px 0;
                    display: grid;
                    grid-row-gap: 140px;
                    grid-column-gap: 10px;
                    grid-template-columns: repeat(12, 1fr);
                }

                .collection-0 {
                    grid-column: 3 / span 6;
                }
                .collection-1 {
                    grid-column: 1 / span 4;
                    grid-row: 2;
                }

                .collection-2    {
                    grid-column: 8 / span 4;
                    grid-row: 2;
                    margin-top: 140px;
                }

                .large .collection-title {
                    font-size: 100px;
                }

                .large .cta-link {
                    margin-left: 6px;
                    font-size: 18px;
                    font-weight: 400;
                }
                .large .cta-links {
                    margin: 20px 0;
                    font-size: 18px;
                    display: flex;
                    align-items: center;
                    color: white;
                }

                .collections-section .cta-links :global(a) {
                    color: white;
                    text-decoration: underline;
                }
                
                .small .cta-link {
                    font-size: 16px;
                    font-weight: 400;
                    color: white;
                }

                .small .cta-links {
                    // margin: 12px 0;
                }

                .collections-section .small :global(.category-tag) {
                    margin: 12px 0;
                }
                
                .small .collection-title {
                    font-size: 50px;
                }
            
                .section-title {
                    color: black;
                    font-size: 64px;
                    // font-weight: 400;
                    margin-bottom: 30px;
                    font-family: 'Elizeth';
                }

                p {
                    font-size: 22px;
                    color: #4d4d4d;
                    width: 500px;
                    margin: 0 auto;
                }

                @media (max-width: 1000px), (pointer: coarse) {
                    p {
                        width: 100%;
                    }
                    .collections-section {
                        padding: 100px 20px;
                    }
                    .section-title {
                        font-size: 56px;
                    }
                    p {
                        font-size: 19px;
                    }
                    .large .collection-title {
                        font-size: 50px;
                    }
                    .large .cta-links {
                        display: block;
                        margin: 0;
                    }
                    .small .cta-link, .large .cta-link {
                        font-size: 19px;
                    }

                    .collections-section .large :global(.category-tag) {
                        margin: 12px 0;
                    }

                    .collections {
                        grid-template-columns: 1fr;
                        grid-gap: 80px;
                        padding: 0;
                        margin-top: 80px;
                    }
                    .collection-0 {
                        grid-column: 1;
                        grid-row: initial;
                    }
                    .collection-1 {
                        grid-column: 1;
                        grid-row: initial;
                    }
                    .collection-2    {
                        grid-column: 1;
                        grid-row: initial;
                        margin-top: 0;
                    }
                }   
            `}</style>
        </div>
    )
}

export default BloomCollectionsSection